import { useCallback } from "react";

import { useTrackImpressionEventByIntersection } from "shared/hooks";
import { getAbsoluteUrl } from "shared/lib/utils";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { RecirculationWidgetImpressionEvent } from "scmp-app/components/tracking/google-analytics-4/types";

type ClickTrackingParameters = {
  entityId?: string;
  index: number;
  isSponsorArticle?: boolean;
  urlAlias?: string;
};

export const sendTopStoriesClickTracking = ({
  entityId,
  index,
  isSponsorArticle,
  urlAlias,
}: ClickTrackingParameters) => {
  if (isSponsorArticle) {
    sendGA4Tracking({
      action: "click",
      category: "recirculation",
      customized_parameters: {
        article_id: entityId,
        destination_url: getAbsoluteUrl(urlAlias),
        page_type: "homepage",
        widget_name: "sponsor_article",
      },
      subcategory: "widget",
    });
    return;
  }

  const widgetName = (() => {
    if (index === 0) return "top_story1";
    if (index <= 3) return "top_story5";
    if (index <= 7) return "top_story8";
    if (index <= 11) return "top_story12";
    return "top_story16";
  })();

  sendGA4Tracking({
    action: "click",
    category: "recirculation",
    customized_parameters: {
      article_id: entityId,
      destination_url: getAbsoluteUrl(urlAlias),
      page_type: "homepage",
      widget_name: widgetName,
    },
    subcategory: "widget",
  });
};

export const useTopStoriesNativeAdImpressionTracking = () => {
  const nativeAdImpressionGA4Event = useCallback<() => RecirculationWidgetImpressionEvent>(
    () => ({
      action: "imp",
      category: "recirculation",
      customized_parameters: {
        page_type: "homepage",
        widget_name: "sponsor_article",
      },
      subcategory: "widget",
    }),
    [],
  );
  const { captureTrackImpressionEventTargetElement } =
    useTrackImpressionEventByIntersection<RecirculationWidgetImpressionEvent>({
      ga4TrackingHandler: sendGA4Tracking,
      getGa4Event: nativeAdImpressionGA4Event,
      options: { isSendGA4Tracking: true, shouldSendOnce: true },
    });
  return captureTrackImpressionEventTargetElement;
};
